import React, {Component, createRef} from "react";
import {connect} from 'react-redux';
import classNames from "classnames";
import FJToolbarCommon from "../view/FJToolbarCommon";
import FJLocalStore from "../../../store/FJLocalStore";
import InlineSVG from "react-inlinesvg";
import FJToolbarIconButton from "../view/FJToolbarIconButton";
import FJToolbarDevider from "../view/FJToolbarDevider";
import RotateLeftSvg from "../../../icon/rotate_left.svg";
import RotateRightSvg from "../../../icon/roteto_right.svg";
import uploadLogoSvg from "../../../icon/upload_logo.svg";
import FJInputFile from "fj-components/FJInputFile";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import {FJToolbarAction} from "../../../redux/action/FJRoot.action";
import FJCanvasStore from "../../../store/FJCanvasStore";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJOverLayPosition from "../view/FJPosition";
import FJViewConstant from "../../../constant/FJViewConstant";
import FJCropIcon from "../../../icon/crop.svg";

class FJToolbarOverLayTextContainer extends Component {

  constructor(props) {
    super(props);
    this.input = createRef();
  }

  componentDidMount() {
    FJCanvasStore.executeSync(FJCanvasStore.command.SUBSCRIBE_DOUBLE_CLICK_IN_TRACK, (graphType) => {
      let {STATIC_IMAGE} = FJCoreConstant;
      if (graphType === STATIC_IMAGE) {
        this.clickInputFile();
      }
    });
  }

  clickInputFile = () => {
    this.input.current.click()
  };

  render() {
    let {
      active,
      rotateLeft,
      rotateRight,
      overlayImageChange,
      positionChange,
      supportPositions,
      mediaStatus,
      position,
      couldMask,
      handleCrop,
    } = this.props;
    let acceptType = FJCoreUtil.getBrowser() === 'Safari' ? 'image/*' : 'image/*';
    let mediaSuccess = mediaStatus === FJViewConstant.MEDIA_STATUS_SUCCESS;
    let itemStyle = {float: 'left', marginRight: '6px'};
    return (
      <FJToolbarCommon className={classNames('c-toolbar-text', {active})}>
        <FJToolbarIconButton onClick={rotateLeft} style={itemStyle} disabled={!mediaSuccess}
                             className='u-tooltip-bottom' tooltip={FJLocalStore._('rotate-left')}
                             icon={<InlineSVG src={RotateLeftSvg} element='div'/>}/>
        <FJToolbarIconButton onClick={rotateRight} style={itemStyle} disabled={!mediaSuccess}
                             className='u-tooltip-bottom' tooltip={FJLocalStore._('rotate-right')}
                             icon={<InlineSVG src={RotateRightSvg} element='div'/>}/>
        <FJToolbarDevider/>
        <FJToolbarIconButton style={itemStyle} disabled={!mediaSuccess} className='u-tooltip-bottom'
                             tooltip={FJLocalStore._('upload-logo')} onClick={this.clickInputFile}
                             icon={<InlineSVG src={uploadLogoSvg} element='div'/>}/>
        <FJInputFile ref={this.input}
                     multiple={false}
                     accept={acceptType}
                     onChange={overlayImageChange}/>
        <FJToolbarIconButton icon={<InlineSVG src={FJCropIcon} element='div'/>}
                             style={{float: 'left', marginRight: '6px'}}
                             onClick={handleCrop}
                             disabled={!mediaSuccess || !couldMask}
                             className='u-tooltip-bottom c-toolbar-icon-btn float-left'
                             tooltip={FJLocalStore._('crop') }
        />
        <FJOverLayPosition disabled={!mediaSuccess}
                           positionChange={positionChange}
                           positionType={position}
                           supportPositions={supportPositions}
                           placement='bottomCenter'/>
      </FJToolbarCommon>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    couldMask: state.toolbar.couldMask,
    supportPositions: state.toolOverlay.supportPositions,
    position: state.toolOverlay.position,
    mediaStatus: state.toolOverlay.mediaStatus,
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    rotateLeft: function () {
      dispatch(FJToolbarAction.setOverlayImageRotationAction(-1));
    },
    rotateRight: function () {
      dispatch(FJToolbarAction.setOverlayImageRotationAction(1));
    },
    overlayImageChange: function (e) {
      dispatch(FJToolbarAction.setOverlayImageSourceAction(e.target.files[0]));
    },
    positionChange: function (position) {
      dispatch(FJToolbarAction.setOverlayPositionAction(position))
    },
    handleCrop: function () {
      dispatch(FJToolbarAction.setCropAction(true));
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(FJToolbarOverLayTextContainer);
